<rt-dropdown #mainDropdown>
  <rt-dropdown-header>{{ 'app.views.view_settings.header' | translate }}</rt-dropdown-header>
  <div class="items">
    <div padding-tb padding-lr-small>
      <rt-views-view-name-input
        [nameControl]="viewForm.controls.name"
        [symbolControl]="viewForm.controls.symbol"
        [layoutType]="viewForm.value.layout!.type!"
        [isViewPredefined]="isViewPredefined()"
        [disabled]="isViewPredefined()"
        [rtTooltip]="'app.views.view_settings.name_disabled_tooltip' | translate"
        [rtTooltipEnabled]="isViewPredefined()"
        rtTooltipPosition="left"
      />
      <rt-views-view-layout-picker
        [formControl]="viewForm.controls.layout.controls.type"
        [layouts]="layouts"
        margin-top
      />
    </div>

    @if (viewForm.value.layout?.type === 'table') {
      <rt-dropdown-item (click)="handleAutoFitClick()">
        <rt-icon prefix name="view-column" />
        <div layout layout-space-between layout-align-items-center>
          {{ 'app.views.view_settings.auto_fit_table' | translate }}
          <rt-toggle [formControl]="viewForm.controls.layout.controls.autoFit" [noLabel]="true" />
        </div>
      </rt-dropdown-item>
    }

    @if (viewForm.value.layout?.type === 'board') {
      <view-settings-swimlanes [layoutControl]="viewForm.controls.layout" [swimlanes]="swimlanes" />
    }

    <view-settings-fields
      [fieldsControl]="viewForm.controls.layout.controls.fields"
      [layoutControl]="viewForm.controls.layout"
    />
    <view-settings-groups
      [layoutControl]="viewForm.controls.layout"
      [groupControl]="viewForm.controls.group"
      [defaultGroup]="dataSource.defaultGroup"
      [groups]="groups"
      [hasBackButton]="openAt() === 'mainTemplate'"
    />

    <view-settings-visibility
      [visibilityControl]="viewForm.controls.visibility"
      [isViewPredefined]="isViewPredefined()"
    />
    <recruitee-view-settings-pinned-filters
      [quickFiltersIdsControl]="viewForm.controls.quickFiltersIds"
    />
    <!--      <rt-dropdown-item>-->
    <!--        <rt-icon prefix name="file-download" />-->
    <!--        {{ 'app.views.view_settings.export_to_csv' | translate }}-->
    <!--      </rt-dropdown-item>-->
    <rt-divider />
    <rt-dropdown-item
      [class.item-disabled]="isViewCreate()"
      [hasHoverEffect]="!isViewCreate()"
      [rtTooltip]="'app.views.view_settings.duplicate_disabled_tooltip' | translate"
      [rtTooltipPosition]="'left'"
      [rtTooltipEnabled]="isViewCreate()"
      (click)="!isViewCreate() && duplicate.emit()"
    >
      <rt-icon prefix name="content-copy" />
      {{ 'app.views.view_settings.duplicate' | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item
      [class.item-disabled]="isDeleteDisabled()"
      [hasHoverEffect]="!isDeleteDisabled()"
      [rtTooltip]="
        (isViewPredefined()
          ? 'app.views.view_settings.delete_predefined_disabled_tooltip'
          : 'app.views.view_settings.delete_disabled_tooltip'
        ) | translate
      "
      [rtTooltipEnabled]="isDeleteDisabled()"
      rtTooltipPosition="left"
      (click)="!isDeleteDisabled() && delete.emit()"
    >
      <rt-icon prefix name="delete" />
      {{ 'app.views.view_settings.delete' | translate }}
    </rt-dropdown-item>
    @if (dataSourceMoreSettingsCmp && hasMoreSettings) {
      <view-settings-more />
    }
  </div>
</rt-dropdown>
